import { Amplify } from 'aws-amplify';

let configured = false;

/**
 * Amplify v6 configuration for the Runner portal.
 *
 * Pool-per-actor + Runner isolation ruling (2026-08-24): this portal
 * authenticates against the DEDICATED Runner Cognito pool through its own
 * /login form. Deliberately:
 *  - NO identity pool — the portal makes no IAM-signed calls (runner-api takes
 *    the id token as a bearer; the gateway verifies it against the Runner pool).
 *  - NO cross-subdomain cookie storage — a Runner session belongs to this origin
 *    only; sharing a `.grocerylistplus.com` cookie with the consumer apps would
 *    be wrong (different pool, different audience).
 *  - NO @glplus/glpweb-shared-libs — the only shared package is the DSL.
 */
export function configureAmplify(): void {
  if (configured) return;
  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID as string;
  const userPoolClientId = import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID as string;
  if (!userPoolId || !userPoolClientId) {
    console.error('[runner-portal] missing Cognito env — auth will not work');
    return;
  }
  Amplify.configure({ Auth: { Cognito: { userPoolId, userPoolClientId } } });
  configured = true;
}
